import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { clearNid } from '../../store/slices/domainOrchestratorPricingCommittee.slice';
import { pathOPCList } from '@pages/OrchestratorPricingCommitteePage/routes/routes.types';
import { IconArrow } from '@assets/icons';

export const GoToListOrchestrator = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    dispatch(clearNid());
    navigate(`/orchestrator-pricing-committee/${pathOPCList}`);
  };

  return (
    <Button
      aria-label="Ir al listado"
      className="p-0"
      variant="link"
      onClick={handleClick}
      data-testid="go-to-list-opc"
    >
      <IconArrow />
    </Button>
  );
};
